import * as React from 'react';

export interface ILeftMenuCategoryPopupEvent {
    id: number;
    name: string;
    isFavorite: boolean;
    stateName: string;
    eventTime: number;
    hasResults: boolean;
    mainResult: { score1: string; score2: string }
}

export interface ILeftMenuEventPopupProps {
    sportName: string;
    categoryName: string;
    eventCount: number;
    events: ILeftMenuCategoryPopupEvent[];
    popupOffset: number;
    onSetAsFavorite: (eventId: number, isFavorite: boolean) => void;
    goToDetail: (detailId: number) => void;
    onToggleEventsPopupVisible: (offset?: number) => void;
}

export const EventsPopup: React.FC<ILeftMenuEventPopupProps> = (props) => {
    return (
        <div className="left-menu-events-popup" style={{ top: props.popupOffset - 20 }} onClick={() => { props.onToggleEventsPopupVisible() }}>
            <div className={`title d-flex`}>
                <span className={`text-uppercase `}>{props.categoryName} ({props.eventCount})</span>
            </div>
            {
                props.events.map(event => (
                    <div className="px-1 py-2" key={event.id}>
                        <div className="d-flex justify-content-between">
                            <a className={`text-truncate ml-1 `} style={{ cursor: "pointer" }}
                                onClick={() => {
                                    props.goToDetail(event.id);
                                }}>{event.name}
                            </a>
                            <span className={`${event.isFavorite ? "fa fa-star" : "far fa-star"}`}
                                onClick={(e) => { e.stopPropagation(); props.onSetAsFavorite(event.id, event.isFavorite) }}>
                            </span>
                        </div>
                        <div className="d-flex justify-content-between px-1 ">
                            <span className="event-state">{event.stateName}{event.eventTime > 0 && <>, {event.eventTime}'</> /* same in leftMenuCategory */}</span>
                            {event.hasResults && <span>{event.mainResult.score1}:{event.mainResult.score2}</span>}
                        </div>
                    </div>
                ))
            }
        </div>
    )
}